import TagCategory from './component'
export { TagCategory }
export default TagCategory